import React from "react";
import "../style.css";

const CardWorkflow = React.memo(({ titel, beschreibung, nummer, image }) => (
  <div className="card-alternate">
    <div className="h3">{titel}</div>
    <div className="image-container">
      <img src={image} className="image" />
    </div>
    <div className="body">
      <div className="bodycopy">{beschreibung}</div>
      <div className="divider">
        <hr className="hr"></hr>
        <div className="h3">{nummer}</div>
      </div>
    </div>
  </div>
));

export default CardWorkflow;
